import React from 'react'
import ReallocationModal from './components/ReallocationModal'
import ReallocationTable from './components/ReallocationTable'
import ReallocationProvider from './components/ReallocationProvider'
import ReallocationTargetModal from './components/ReallocationTargetModal'

const ReallocationPage = () => {
  return (
    <div>
      <ReallocationProvider>
        <ReallocationModal />
        <ReallocationTargetModal />
        <ReallocationTable />
      </ReallocationProvider>
    </div>
  )
}

export default ReallocationPage
